import React, { useEffect } from "react";
import { SEO } from "../../components/common/SEO";
import { Container, styled, Theme } from "@mui/system";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import ReactRouterLink from "../../components/common/ReactRouterLink";
import { useDispatch, useSelector } from "react-redux";
import {
  confirmUserAccount,
  fetchUserByUniqueId,
} from "../../redux/actions/userActions";
import { RootState } from "../../redux/store";
import { CenteredLoading } from "../../components/common/CenteredLoading";
import { setCookie } from "../../utils";
import { USER_LOGIN_COOKIE } from "../../constants";

interface IProps {}

const NotFoundContainer = styled("div")(({ theme }: { theme: Theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0)), url("/fp-hero-bkg2.jpeg")`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundAttachment: "fixed",
  color: "#fff",
  textAlign: "center",
  padding: "20px",
  paddingTop: theme.spacing(4),
  backdropFilter: "blur(8px)",
}));

const OvalButton = styled(Button)({
  marginTop: 4,
  backgroundColor: "#e78758",
  color: "#fff",
  borderRadius: "50px",
  padding: "8px 16px",
  "&:hover": {
    backgroundColor: "#c56a3e",
  },
});

const Confirm: React.FC<IProps> = () => {
  const { id, email } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, users, error } = useSelector(
    (state: RootState) => state.users
  );

  useEffect(() => {
    if (id && email) {
      dispatch(confirmUserAccount(Number(id), email));
    } else {
      navigate("/");
    }
  }, [id, email, dispatch]);

  if (!loading && users && users.length <= 0) {
    navigate("/");
    return null;
  }

  return loading || !users ? (
    <CenteredLoading />
  ) : (
    <>
      <SEO
        title="Account Confirmed • FiddlePiddle • Toys Marketplace"
        description="Your email has been successfully confirmed! Access your account and explore all the features waiting for you. Thank you for joining us."
        keywordsContent="Confirm, toys marketplace, marketplace for toys, fiddlepiddle"
      />
      <NotFoundContainer>
        <Typography
          variant="h1"
          sx={{
            fontSize: "2em",
            marginBottom: "1rem",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
          }}
        >
          ✔️ Confirmed
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "1rem",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
          }}
        >
          Your email has been successfully confirmed! Access your account and
          explore all the features waiting for you. Thank you for joining us.
        </Typography>
        <ReactRouterLink
          to="/account"
          linkElement={
            <OvalButton
              variant="contained"
              sx={{ marginTop: 2, lineHeight: "unset" }}
            >
              My Account
            </OvalButton>
          }
        />
      </NotFoundContainer>
    </>
  );
};

export default Confirm;
